import * as Sentry from '@sentry/react'

import { environment, environmentVariables } from '../utils/environmentVariables'

export const loadSentry = (): void => {
  Sentry.init({
    dsn: environmentVariables('SENTRY_DSN'),
    environment,
    tracesSampleRate: 0,
    enabled: environmentVariables('SENTRY_ENABLED') != 'false',
    denyUrls: [
      // Browser extensions
      /extensions\//i,
      /^safari-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^:\/\/hidden\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      /^webkit-masked-url:\/\/hidden\//i,
    ],
    ignoreErrors: [
      // Web crawler errors
      /moat_px is not defined/i,
      /IMUID is not defined/i,
      /__cmp is not defined/i,
      /apstagLOADED is not defined/i,
      /Cannot read properties of undefined \(reading 'loaded'\)/i,
      /Cannot read properties of undefined \(reading 'outputCurrentConfiguration'\)/i,
      /Cannot read properties of undefined \(reading 'cmp'\)/i,
      /Cannot read properties of undefined \(reading 'config'\)/i,
      /Cannot read properties of undefined \(reading 'get'\)/i,
      /Cannot read properties of undefined \(reading 'variables'\)/i,
      /Cannot read properties of undefined \(reading 'ns'\)/i,
      /Cannot read properties of undefined \(reading 'closingEls'\)/i,
      // Seems related to google translate
      /undefined is not an object \(evaluating 'a\..+'\)/i,
      // Chrome or Edge iOS injection
      /undefined is not an object \(evaluating '__gCrWeb\.learningToolsRuntimeBridge\.raiseMessageFromHost'\)/i,
      /undefined is not an object \(evaluating 'window\.webkit\.messageHandlers'\)/i,
      // Microsoft Outlook SafeLink crawlers
      /Object Not Found Matching Id/i,
      // Known recaptcha error (https://github.com/getsentry/sentry-javascript/issues/2514#issuecomment-603971338)
      /Non-Error promise rejection captured with value: Timeout/i,
      // Other known browser or extensions errors
      /__show__deepen/i,
      /_avast_submit/i,
      /cordova/i,
      /DataCloneError/i,
      /feedConf/i,
      /ibFindAllVideos/i,
      /jQuery/i,
      /myGloFrameList/i,
      /MyIPhoneApp/i,
      /snapchat.com/i,
      /vid_mate_check is not defined/i,
      /win\.document\.body/i,
      /window\._sharedData\.entry_data/i,
      /window\.regainData/i,
      /ztePageScrollModule/i,
    ],
    // There is no "ignoredPaths" built-in configuration, we are forced to do it ourselves by parsing stacktrace.
    // If one frame of "upper" error object stacktrace match one of the listed path, the error is discarded.
    beforeSend(event) {
      const ignoredPaths = [
        // OneTrust is a very buggy library and we cannot change cookie security provider for now.
        // Let's live with it and simply ignore it's errors.
        /otSDKStub/i,
        /otBannerSdk/i,
      ]
      const frames = event.exception?.values?.[0]?.stacktrace?.frames
      const pathMatch = ignoredPaths.some((path) => frames?.some((frame) => frame?.filename?.match(path)))
      if (pathMatch) {
        return null
      } else {
        return event
      }
    },
  })
}
